import {
  combineReducers,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import OCRService from "services/OCRService";

let initialState = { data: "" };

export const readOCRSalary = createAsyncThunk("ocr/salary", async (file) => {
  const response = await OCRService.read(file);
  return response?.results;
});

export const readOCRContractTerm = createAsyncThunk(
  "ocr/contractTerm",
  async (file) => {
    const response = await OCRService.read(file);
    return response?.results;
  }
);
export const readOCRAllowance = createAsyncThunk(
  "ocr/allowance",
  async (file) => {
    const response = await OCRService.read(file);
    return response?.results;
  }
);
export const readOCRBenefit = createAsyncThunk("ocr/benefit", async (file) => {
  const response = await OCRService.read(file);
  return response?.results;
});
export const readOCRBonus = createAsyncThunk("ocr/bonus", async (file) => {
  const response = await OCRService.read(file);
  return response?.results;
});

export const ocrSalarySlice = createSlice({
  name: "ocr/salary",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(readOCRSalary, builder);
  },
});

export const ocrContractTermSlice = createSlice({
  name: "ocr/contractTerm",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(readOCRContractTerm, builder);
  },
});

export const ocrAllowanceSlice = createSlice({
  name: "ocr/allowance",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(readOCRAllowance, builder);
  },
});
export const ocrBenefitSlice = createSlice({
  name: "ocr/benefit",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(readOCRBenefit, builder);
  },
});
export const ocrBonusSlice = createSlice({
  name: "ocr/bonus",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(readOCRBonus, builder);
  },
});

export const selectOCRSalary = (state) => state.ocr?.salary;
export const selectOCRContractTerm = (state) => state.ocr?.contractTerm;
export const selectOCRAllowance = (state) => state.ocr?.allowance;
export const selectOCRBenefit = (state) => state.ocr?.benefit;
export const selectOCRBonus = (state) => state.ocr?.bonus;

export default combineReducers({
  salary: ocrSalarySlice.reducer,
  contractTerm: ocrContractTermSlice.reducer,
  allowance: ocrAllowanceSlice.reducer,
  benefit: ocrBenefitSlice.reducer,
  bonus: ocrBonusSlice.reducer,
});
